import { Entitlements, UserProfile } from '@ascend/authz';

export type AppUserProfile = UserProfile<Entitlements>;

export const ClientPartyType = {
  prefix: 'C',
  type: 'Client',
};
export const SubcodePartyType = {
  prefix: 'S',
  type: 'Subcode',
};

export const PartyTypes = [ClientPartyType, SubcodePartyType];
